import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AboutUsSection from "../../components/about/AboutUS";
import "./Project.css";
import one from "../../assest/project.png";
import ArrowImg from "../../assest/arrow.png";
import Testimonial from "../../components/home/Testimonial";
import FaqSection from "../../components/about/FAQ";
import Blogs from "../../components/home/Blogs";

const Project = () => {
  const { language } = useSelector((state) => state.language);
  const [filter, setFilter] = useState("All");

  const translations = {
    gb: {
      heading: "Projects",
      buttonText: "Explore Services",
      filters: {
        all: "All",
        ongoing: "Ongoing",
        completed: "Completed",
      },
      projectData: [
        {
          id: 1,
          image: one,
          status: "Ongoing",
          title: "Ministry of Health Upgrade",
          description:
            "Full manpower & equipment deployment for national infrastructure development.",
          location: "Riyadh, KSA",
          client: "Ministry of Health",
          year: "2022",
          duration: "1Y 6M",
        },
        {
          id: 2,
          image: one,
          status: "Completed",
          title: "Commercial Tower Construction",
          description:
            "High-rise building construction with full equipment and manpower support.",
          location: "Jeddah, KSA",
          client: "Al Rajhi Construction",
          year: "2023",
          duration: "1Y",
        },
        {
          id: 3,
          image: one,
          status: "Ongoing",
          title: "University Campus Expansion",
          description:
            "Infrastructure development for new academic buildings and facilities.",
          location: "Dammam, KSA",
          client: "King Fahd University",
          year: "2023",
          duration: "2Y",
        },
        {
          id: 4,
          image: one,
          status: "Completed",
          title: "Hospital Renovation",
          description:
            "Complete renovation of medical facilities with specialized equipment.",
          location: "Mecca, KSA",
          client: "Ministry of Health",
          year: "2022",
          duration: "1Y 3M",
        },
      ],
    },
    sa: {
      heading: "المشاريع",
      buttonText: "استكشف الخدمات",
      filters: {
        all: "الكل",
        ongoing: "قيد التنفيذ",
        completed: "مكتمل",
      },
      projectData: [
        {
          id: 1,
          image: one,
          status: "قيد التنفيذ",
          title: "ترقية وزارة الصحة",
          description:
            "نشر كامل للقوى العاملة والمعدات لتطوير البنية التحتية الوطنية.",
          location: "الرياض، المملكة العربية السعودية",
          client: "وزارة الصحة",
          year: "2022",
          duration: "1 سنة 6 أشهر",
        },
        {
          id: 2,
          image: one,
          status: "مكتمل",
          title: "بناء برج تجاري",
          description: "بناء ناطحة سحاب بدعم كامل من المعدات والقوى العاملة.",
          location: "جدة، المملكة العربية السعودية",
          client: "الراجحي للإنشاءات",
          year: "2023",
          duration: "1 سنة",
        },
        {
          id: 3,
          image: one,
          status: "قيد التنفيذ",
          title: "توسعة الحرم الجامعي",
          description:
            "تطوير البنية التحتية للمباني والمرافق الأكاديمية الجديدة.",
          location: "الدمام، المملكة العربية السعودية",
          client: "جامعة الملك فهد",
          year: "2023",
          duration: "سنتين",
        },
        {
          id: 4,
          image: one,
          status: "مكتمل",
          title: "تجديد المستشفى",
          description: "تجديد كامل للمرافق الطبية بمعدات متخصصة.",
          location: "مكة، المملكة العربية السعودية",
          client: "وزارة الصحة",
          year: "2022",
          duration: "1 سنة 3 أشهر",
        },
      ],
    },
    fr: {
      heading: "Projets",
      buttonText: "Explorer les services",
      filters: {
        all: "Tous",
        ongoing: "En cours",
        completed: "Terminé",
      },
      projectData: [
        {
          id: 1,
          image: one,
          status: "En cours",
          title: "Modernisation du ministère de la Santé",
          description:
            "Déploiement complet de main-d'œuvre et d'équipements pour le développement des infrastructures nationales.",
          location: "Riyad, Arabie Saoudite",
          client: "Ministère de la Santé",
          year: "2022",
          duration: "1 an 6 mois",
        },
        {
          id: 2,
          image: one,
          status: "Terminé",
          title: "Construction de tour commerciale",
          description:
            "Construction de gratte-ciel avec un soutien complet en équipement et en main-d'œuvre.",
          location: "Jeddah, Arabie Saoudite",
          client: "Al Rajhi Construction",
          year: "2023",
          duration: "1 an",
        },
        {
          id: 3,
          image: one,
          status: "En cours",
          title: "Extension du campus universitaire",
          description:
            "Développement d'infrastructures pour de nouveaux bâtiments et installations académiques.",
          location: "Dammam, Arabie Saoudite",
          client: "Université King Fahd",
          year: "2023",
          duration: "2 ans",
        },
        {
          id: 4,
          image: one,
          status: "Terminé",
          title: "Rénovation d'hôpital",
          description:
            "Rénovation complète des installations médicales avec des équipements spécialisés.",
          location: "La Mecque, Arabie Saoudite",
          client: "Ministère de la Santé",
          year: "2022",
          duration: "1 an 3 mois",
        },
      ],
    },
    de: {
      heading: "Projekte",
      buttonText: "Dienstleistungen erkunden",
      filters: {
        all: "Alle",
        ongoing: "Laufend",
        completed: "Abgeschlossen",
      },
      projectData: [
        {
          id: 1,
          image: one,
          status: "Laufend",
          title: "Upgrade des Gesundheitsministeriums",
          description:
            "Vollständiger Einsatz von Personal und Ausrüstung für die nationale Infrastrukturentwicklung.",
          location: "Riad, Saudi-Arabien",
          client: "Gesundheitsministerium",
          year: "2022",
          duration: "1J 6M",
        },
        {
          id: 2,
          image: one,
          status: "Abgeschlossen",
          title: "Geschäftsturm Bau",
          description:
            "Hochhausbau mit voller Ausrüstungs- und Personalsupport.",
          location: "Dschidda, Saudi-Arabien",
          client: "Al Rajhi Bau",
          year: "2023",
          duration: "1J",
        },
        {
          id: 3,
          image: one,
          status: "Laufend",
          title: "Campus-Erweiterung",
          description:
            "Infrastrukturentwicklung für neue akademische Gebäude und Einrichtungen.",
          location: "Dammam, Saudi-Arabien",
          client: "King Fahd Universität",
          year: "2023",
          duration: "2J",
        },
        {
          id: 4,
          image: one,
          status: "Abgeschlossen",
          title: "Krankenhausrenovierung",
          description:
            "Komplette Renovierung der medizinischen Einrichtungen mit Spezialausrüstung.",
          location: "Mekka, Saudi-Arabien",
          client: "Gesundheitsministerium",
          year: "2022",
          duration: "1J 3M",
        },
      ],
    },
  };

  const t = translations[language] || translations.gb;
  const isRtl = language === "sa";

  const getFilterKey = (status) => {
    const filterMap = {
      All: "all",
      Ongoing: "ongoing",
      Completed: "completed",
    };
    return filterMap[status] || "all";
  };

  const filteredProjects =
    filter === "All"
      ? t.projectData
      : t.projectData.filter(
          (project) => project.status === t.filters[getFilterKey(filter)]
        );

  return (
    <>
      <AboutUsSection
        heading={t.heading}
        buttonText={t.buttonText}
        language={language}
      />

      <div className="container project-container" dir={isRtl ? "rtl" : "ltr"}>
        <div className="row-grid">
          <div
            className={`filter-buttons border rounded-5 p-2 ${isRtl ? "text-right" : "text-left"}`}
          >
            {["All", "Ongoing", "Completed"].map((status) => (
              <li key={status} className="inline-block">
                {status === "Ongoing" || status === "Completed" ? (
                  <Link
                    to={
                      status === "Ongoing" ? "/ongoing-projects" : "/completed"
                    }
                  >
                    <button
                      className={`filter-btn ${filter === status ? "active" : ""}`}
                      onClick={() => setFilter(status)}
                    >
                      {t.filters[getFilterKey(status)]}
                    </button>
                  </Link>
                ) : (
                  <button
                    className={`filter-btn ${filter === status ? "active" : ""}`}
                    onClick={() => setFilter(status)}
                  >
                    {t.filters[getFilterKey(status)]}
                  </button>
                )}
              </li>
            ))}
          </div>

          <div className="card-grid">
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                className="card position-relative overflow-hidden rounded "
              >
                <Link to={`/Project-Details`}>
                  <img
                    src={project.image}
                    alt={project.title}
                    className="card-img-top"
                  />
                </Link>

                <span
                  className="position-absolute top-0 end-0 m-2 bg-danger rounded-circle p-2 d-flex align-items-center justify-content-center"
                  style={{ transition: "transform 0.2s ease-in-out" }}
                >
                  <Link to={`/Project-Details`}>
                    <img
                      src={ArrowImg}
                      alt="View details"
                      className="img-fluid"
                      style={{
                        width: "32px",
                        height: "32px",
                        transition: "transform 0.2s ease-in-out",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.2)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1.0)")
                      }
                    />
                  </Link>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Testimonial language={language} />
      <Blogs language={language} />
      <FaqSection language={language} />
    </>
  );
};

export default Project;
